import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  return {
    builder: {
      height: '100%'
    },
    header: _defineProperty({
      paddingTop: componentTheme.headerPadding,
      maxWidth: '79.5rem',
      margin: 'auto'
    }, mp, {
      display: 'none'
    }),
    alert: {
      paddingLeft: componentTheme.headerPadding,
      paddingRight: componentTheme.headerPadding
    },
    footer: {
      padding: '1rem',
      display: 'flex',
      justifyContent: 'flex-end'
    }
  };
};
export default generateStyle;